module.exports = __webpack_public_path__ + "static/media/jesse.miettinen.55d1972c.jpg";